export const errorHandler = (error: Error, componentStack: string) => {
  // TODO: Send to Slack and Sentry
  console.error(error);
};
